export default [
  {
    path: "/dashboard",
    name: "dashboard",
    label: "Dashboard",
    component: () => import("@/components/home/MenuDashboard.vue"),
  },
  {
    path: "/dashboard/vendas",
    name: "dashboard.vendas",
    label: "Vendas",
    component: () => import("@/components/dashboards/vendas/dashboard-vendas.vue"),
  },
  {
    path: "/dashboard/vendas-representante",
    name: "dashboard.minhas-vendas",
    label: "Minhas Vendas",
    component: () => import("@/components/dashboards/vendas/dashboard-vendas-representante.vue"),
  },
  {
    path: "/dashboard/otif",
    name: "dashboard.otif",
    label: "Logística",
    component: () => import("@/components/logistica/dashboard/dashboard-otif.vue"),
  },
  {
    path: "/dashboard/oee",
    name: "dashboard.oee",
    label: "Produção",
    component: () => import("@/components/pcp/producao/cadastro-producao/dashboard-producao.vue"),
  },
  {
    path: "/dashboard/financeiro",
    name: "dashboard.financeiro",
    label: "Financeiro",
    component: () => import("@/components/dashboards/financeiro/dashboard-financeiro.vue"),
  },
  {
    path: "/dashboard/financeiro/fleuriet",
    name: "dashboard.financeiro.fleuriet",
    label: "Ind. Fleuriet",
    component: () => import("@/components/dashboards/financeiro/indicadores/financeiro-fleuriet.vue"),
  },
];
